import { ControlType, FieldBase } from './field-base';
import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

export class CheckboxField extends FieldBase<boolean> {
  readonly controlType: ControlType = 'checkbox';
}

@Pipe({
  name: 'sanitizeCheckboxLabel',

  pure: true,
})
export class SanitizeCheckboxLabelPipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
  ) {}

  transform(value: string, required: boolean): string {
    const translatedValue = this.translateService.instant(value);
    let sanitizedValue = this.sanitizer.sanitize(SecurityContext.HTML, translatedValue);
    if (required) {
      sanitizedValue = sanitizedValue.concat(' *');
    }
    return sanitizedValue;
  }
}
